module.exports = __webpack_public_path__ + "fa-brands-400.3b89dd103490708d19a9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.ttf
// module chunks = styles